module.exports = __webpack_public_path__ + "img/Inspection5.616c443f.png";